module.exports = __webpack_public_path__ + "img/Google.04ea3d5.svg";